<template>
  <el-dialog :visible="showDialog" @close="cancel" width="50%" append-to-body :close-on-click-modal="false">
    <template slot="title">
      <plt-dict-box class="dialog-title" :value="formData.toMember" namespace="bizObjects" id="member" />
    </template>
    <div class="chat-app">
      <div v-for="(message,index) in messages" :key="message.id" class="chat-messages">
        <div class="chat-time" v-if="message.messageTime">
          <div class="timtTxt">{{message.messageTime}}</div>
        </div>
        <div class="left-message-container" v-if="message.fromMember === '2'">
          <div class="img" style="margin-right:10px"><img src="@/assets/image/chatLogo4.jpg" alt="" class="avatar-img" mode="widthFix" /></div>
          <div class="left-bottom-message-name-box">
            <div class="name"><plt-dict-box :value="message.fromMember" namespace="bizObjects" id="member" /></div>
            <div class="left-bottom-message-box">
              <div class="left-message message" @contextmenu.prevent="openContextMenu($event,message.id,message.message)">
                <div class="txt">{{message.message}}</div>
              </div>
              <div class="arrow arrow-left"></div>
            </div>
          </div>
        </div>
        <div class="left-message-container" v-if="message.fromMember === '2'&&message.refId&&message.refMsg">
          <div class="left-quote-message quote">{{message.refMsg.message}}</div>
        </div>
        <div class="right-message-container" v-if="message.fromMember !== '2'">
          <div class="right-bottom-message-name-box">
            <div class="name"><plt-dict-box :value="message.fromUser" namespace="bizObjects" id="user" /></div>
            <div class="right-bottom-message-box">
              <div class="right-message message" @contextmenu.prevent="openContextMenu($event,message.id,message.message)">
                <div class="txt">{{message.message}}</div>
              </div>
              <div class="arrow arrow-right"></div>
            </div>
          </div>
          <div class="img" style="margin-left:10px"><img src="@/assets/image/chatLogo5.jpg" alt="" class="avatar-img" mode="widthFix" /></div>
        </div>
        <div class="right-message-container" v-if="message.fromMember !== '2'&&message.refId&&message.refMsg">
          <div class="right-quote-message quote">{{message.refMsg.message}}</div>
        </div>
      </div>

    </div>
    <div class="chat-input">
      <textarea ref="textareaRef" v-model="formData.message" contenteditable="true" @keydown="keydown" type="textarea" placeholder="请输入聊天内容" />
      <el-button @click="sendMessage" size="mini" class="elButton">发送</el-button>
      <div v-if="quoteId" class="quote-container">
        <div class="quote">回复：{{quote}}</div>
        <div class="close" @click="closeQuote" style="margin-left:10px"><i class="el-icon-close"></i></div>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <ul v-if="contextMenuVisible" :style="{left:left+'px',top:top+'px'}" class="contextmenu" id="contextmenu">
        <li @click="onQuote()">
          引用
        </li>
      </ul>
    </transition>

  </el-dialog>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      showDialog: false,
      messages: [],
      // 表单属性
      formData: {
        bidId: "",
        fromMember: "",
        message: "",
        refId: "",
        toMember: "",
      },
      id: "",
      idKey: "",
      chatUrl: "",
      sendMsgUrl: "",
      // 右键属性
      contextMenuVisible: false,
      left: 0,
      top: 0,
      // 引用内容
      temporarilyId: "", // 右键临时保存的回复id
      temporarilyQuote: "", // 右键临时保存的回复内容
      quoteId: "", // 点击引用后确定的引用id
      quote: "", // 点击引用后确定的引用内容
    };
  },
  watch: {
    contextMenuVisible(val) {
      let that = this;
      var cm = function (e) {
        let sp = document.getElementById("contextmenu");
        if (sp && !sp.contains(e.target)) {
          that.closeMenu();
        }
      };
      if (val) {
        document.body.addEventListener("click", (e) => cm(e));
      } else {
        document.body.removeEventListener("click", (e) => cm(e));
      }
    },
  },
  methods: {
    async init({ id, toMember, idKey, chatUrl, sendMsgUrl }) {
      this.id = id;
      this.idKey = idKey;
      this.chatUrl = chatUrl;
      this.sendMsgUrl = sendMsgUrl;
      this.formData[idKey] = id;
      this.formData.toMember = toMember;
      this.formData.fromMember = sessionStorage.getItem("memberId");
      this.formData.message = "";
      this.showDialog = true;
      await this.getChats(id, idKey, chatUrl);
      this.getChatScrollDom();
    },
    // 获取聊天记录
    async getChats(id, idKey, chatUrl) {
      let url = chatUrl;
      let body = { [idKey]: id };
      this.messages = await this.invoke(url, body);
      this.messages.forEach((item) => {
        let curTimestamp = new Date().getTime();
        let timestamp = new Date(item.createTime).getTime();
        var timestampDiff = curTimestamp - timestamp; // 聊天时间戳与当前时间戳相差秒数
        if (timestampDiff < 60 * 60 * 12 * 1000) {
          // 十二个小时
          item.timeTxt = new Date(item.createTime).Format("hh:mm");
        } else {
          item.timeTxt = new Date(item.createTime).Format("yyyy-MM-dd hh:mm");
        }
      });
      for (let i = 0; i < this.messages.length; i++) {
        this.messages[i].messageTime = this.messages[i].timeTxt;
        if (i > 0 && this.messages[i].timeTxt === this.messages[i - 1].timeTxt) {
          this.messages[i].messageTime = "";
        }
      }
    },

    // 发送消息
    async sendMessage() {
      if (this.formData.message) {
        let url = this.sendMsgUrl;
        if (this.quoteId) {
          this.formData.refId = this.quoteId;
        }
        let data = this.formData;
        await this.invoke(url, data);
        this.formData.message = "";
        this.closeQuote();
        await this.getChats(this.id, this.idKey, this.chatUrl);
        this.getChatScrollDom();
      }
    },
    // 引用
    onQuote() {
      this.quoteId = this.temporarilyId;
      this.quote = this.temporarilyQuote;
      this.closeMenu();
      // 获取输入框焦点
      this.$refs["textareaRef"].focus();
    },
    // 关闭引用
    closeQuote() {
      this.quoteId = "";
      this.quote = "";
      this.temporarilyId = "";
      this.temporarilyQuote = "";
      this.formData.refId = "";
    },
    getChatScrollDom() {
      this.$nextTick(() => {
        let msg = document.getElementsByClassName("chat-app"); // 获取对象
        setTimeout(() => {
          msg[0].scrollTop = msg[0].scrollHeight; // 滚动高度
        }, 0);
      });
    },
    // enter与shift+enter
    keydown(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation(); //Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        if (e.keyCode == 13) {
          this.sendMessage();
        }
      }
    },
    // 右键
    openContextMenu(e, id, message) {
      this.contextMenuVisible = true;
      this.temporarilyId = id;
      this.temporarilyQuote = message;
      this.left = e.clientX + 1;
      this.top = e.clientY + 1;
      // FIX 右键菜单边缘化位置处理
      this.$nextTick(() => {
        let sp = document.getElementById("contextmenu");
        if (document.body.offsetWidth - e.clientX < sp.offsetWidth) {
          this.left = document.body.offsetWidth - sp.offsetWidth + 1;
          this.top = e.clientY + 1;
        }
      });
    },
    // 关闭右键菜单
    closeMenu() {
      this.contextMenuVisible = false;
    },
    cancel() {
      this.showDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  background: #f5f5f5;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom: 1px solid #e7e7e7;
  padding: 15px 20px;

  .el-dialog__title {
    color: #232323;
  }
  .el-dialog__close {
    color: #232323;
  }
}
::v-deep .el-dialog__body {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 0 !important;
}
::v-deep .el-dialog__footer {
  background: #f5f5f5;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-radius: 6px;
}
::v-deep .el-dialog {
  border-radius: 6px;
}
.dialog-title {
  font-size: 18px;
  font-weight: 500;
  color: #000;
}
.chat-app {
  position: relative;
  height: 50vh;
  width: 100%;
  background-color: #f5f5f5;
  overflow-y: scroll;
  border-radius: 6px;
  overflow: auto;
  padding: 15px 15px 15px 15px;
  color: #232323;
  .chat-messages {
    margin-top: 15px;
    .chat-time {
      display: flex;
      justify-content: center;
      margin-bottom: 5px;
      .timtTxt {
        display: inline-block;
        background-color: #dadada;
        color: #fff;
        padding: 2px 5px;
        border-radius: 3px;
      }
    }
    .left-message-container {
      display: flex;
      justify-content: left;
      .left-bottom-message-name-box {
        width: 100%;
        margin-top: -4px;
        .name {
          color: #b2b2b2;
          margin: -2px 0 4px 5px;
          font-size: 12px;
        }
        .left-bottom-message-box {
          display: flex;
          justify-content: left;
          flex-direction: row-reverse; // 反转元素 目的是因为DIV无法选择前面的元素 因此hover无法改变箭头的颜色
        }
      }

      .left-message {
        background: #fff;
      }
      .left-message:hover {
        background: #ebebeb;
      }
      .arrow-left {
        border-right: 8px solid #fff;
        margin: 12px 0 0 -14px;
      }
      .left-message:hover + .arrow-left {
        border-right: 8px solid #ebebeb;
        margin: 12px 0 0 -14px;
      }
    }
    .right-message-container {
      display: flex;
      justify-content: right;
      .right-bottom-message-name-box {
        width: 100%;
        margin-top: -4px;
        text-align: right;
        .name {
          color: #b2b2b2;
          margin: -2px 5px 4px 0px;
          font-size: 12px;
        }
        .right-bottom-message-box {
          display: flex;
          justify-content: right;
          // align-items: center;
        }
      }
      .right-message {
        background: #a9e978;
      }
      .right-message:hover {
        background: #89d961;
      }
      .arrow-right {
        border-left: 8px solid #a9e978;
        margin: 12px -14px 0 0px;
      }
      .right-message:hover + .arrow-right {
        border-left: 8px solid #89d961;
        margin: 12px -14px 0 0px;
      }
    }
    .message {
      max-width: 60%;
      border-radius: 5px;
      padding: 8px 10px;
      text-align: left;
      font-size: 14px;
      overflow-wrap: break-word;
      .txt {
        white-space: pre-line;
      }
    }
    .img {
      width: 36px;
      height: 36px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      .avatar-img {
        width: 36px;
        height: 36px;
      }
    }
    .arrow {
      width: 18px;
      height: 0;
      border: 6px solid transparent;
    }
    .quote {
      background: #e8e8e8;
      color: #797979;
      padding: 5px 8px;
      border-radius: 3px;
      max-width: 40%;
      font-size: 14px;
      white-space: pre-line;
    }
    .left-quote-message {
      margin: 6px 0px 0 50px;
    }
    .right-quote-message {
      margin: 6px 50px 0 0;
    }
  }
}
::v-deep .el-textarea {
  width: 100% !important;
  height: 100% !important;
  textarea {
    height: 100% !important;
  }
}
::v-deep .el-textarea__inner {
  background: #f5f5f5;
}
::v-deep .el-button {
  background: #e9e9e9;
  color: #07c160;
}
::v-deep .el-button:hover {
  background: #d2d2d2;
  color: #07c160;
}
::v-deep .el-button--mini {
  padding: 8px 26px;
}
.chat-input {
  height: 20vh;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 2000;
  position: relative;
  textarea {
    padding: 3px 5px;
    width: 100% !important;
    height: 100% !important;
    border: 1px solid #e2e1e1;
    background: #f5f5f5;
  }
  .elButton {
    position: absolute;
    right: 20px;
    bottom: 14px;
  }
  .quote-container {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(0, -100%);
    z-index: 3000;
    white-space: pre-line;
    background: #e8e8e8;
    color: #797979;
    padding: 5px 8px;
    display: flex;

    .close {
      cursor: pointer;
    }
    .close:hover {
      color: #07c160;
    }
  }
}
// 滚动条
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  border-radius: 15px;
  -webkit-border-radius: 15px;
}
::-webkit-scrollbar-track-piece {
  background-color: #f5f5f5;
  border-radius: 15px;
  -webkit-border-radius: 15px;
}
::-webkit-scrollbar-thumb:vertical {
  height: 8px;
  background-color: #d2d2d2;
  border-radius: 15px;
  -webkit-border-radius: 15px;
}
::-webkit-scrollbar-thumb:horizontal {
  width: 8px;
  background-color: #d2d2d2;
  border-radius: 15px;
  -webkit-border-radius: 15px;
}
.el-popup-parent--hidden {
  padding-right: 0 !important;
}
.contextmenu {
  position: fixed;
  width: 100px;
  margin: 0;
  border-radius: 0px;
  background: #fff;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 3000;
  list-style-type: none;
}
.contextmenu hr {
  margin: 5px 0;
  border: none;
  height: 1px;
  font-size: 0px;
  background-color: #ebeef5;
}
.contextmenu li {
  display: flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
  line-height: 30px;
  padding: 0 17px;
  color: #606266;
}
.contextmenu li i {
  font-size: 14px;
  margin-right: 10px;
}
.contextmenu li:hover {
  background-color: #ecf5ff;
  color: #66b1ff;
}
.contextmenu li.disabled {
  cursor: not-allowed;
  color: #bbb;
  background: transparent;
}
</style>